module.exports = __webpack_public_path__ + "img/tokyo.35300e94.jpg";